import { useState } from "react";
import Modal from "../../../components/modals/Modal";
import { IconPlus, IconStethoscope } from "../../../components/icons/IconsMedico";
import { EmptyState } from "../../../components/utils/Utils";
import "./Disponibilidad.css";
import "./Servicios.css";

const TIPO_SERVICIO_LABELS = {
    ESPECIALIDAD: "Especialidad",
    PRACTICA: "Práctica",
};

const formatCosto = (costo) =>
    new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 }).format(costo || 0);

const Servicios = ({ servicios = [], serviciosDisponibles = [], loading, error, onAgregarServicio }) => {
    const [modalAbierto, setModalAbierto] = useState(false);
    const [servicioSeleccionado, setServicioSeleccionado] = useState("");
    const [guardando, setGuardando] = useState(false);
    const [accionError, setAccionError] = useState("");

    const abrirModal = () => {
        setAccionError("");
        setServicioSeleccionado(serviciosDisponibles[0]?.id || "");
        setModalAbierto(true);
    };

    const agregar = async () => {
        if (!servicioSeleccionado) {
            setAccionError("Seleccioná un servicio para agregar.");
            return;
        }

        setGuardando(true);
        setAccionError("");

        try {
            await onAgregarServicio(servicioSeleccionado);
            setModalAbierto(false);
        } catch (requestError) {
            setAccionError(requestError.message);
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div className="medico-section">
            <div className="medico-section__header">
                <div>
                    <p className="eyebrow">Cartera</p>
                    <h2>Mis servicios</h2>
                </div>
                <button
                    className="primary-button"
                    onClick={abrirModal}
                    disabled={serviciosDisponibles.length === 0}
                    title={serviciosDisponibles.length === 0 ? "No hay servicios disponibles para agregar" : undefined}
                >
                    <IconPlus /> Agregar servicio
                </button>
            </div>

            {error && (
                <div className="patient-state patient-state--error">
                    {error}
                </div>
            )}

            {loading ? (
                <div className="patient-state">
                    <div className="patient-state__loader" />
                    <p>Cargando servicios...</p>
                </div>
            ) : servicios.length === 0 ? (
                <EmptyState
                    icon={<IconStethoscope />}
                    title="No tenés servicios asignados."
                    subtitle="Agregá un servicio para que los pacientes puedan reservar turnos con vos."
                />
            ) : (
                <div className="servicios-grid">
                    {servicios.map((servicio) => (
                        <div key={servicio.id} className="franja-card">
                            <div className="franja-card__sede">
                                <IconStethoscope />
                                <span>{servicio.nombre}</span>
                            </div>
                            <div className="franja-card__sede">
                                <span>{TIPO_SERVICIO_LABELS[servicio.tipoServicio] || "Sin tipo"}</span>
                            </div>
                            <div className="franja-card__sede">
                                <span>{servicio.duracionEnMinutos ? `${servicio.duracionEnMinutos} min` : "—"}</span>
                            </div>
                            <div className="franja-card__sede">
                                <span>{servicio.costoConsulta != null ? formatCosto(servicio.costoConsulta) : "—"}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {modalAbierto && (
                <Modal title="Agregar servicio" onClose={() => setModalAbierto(false)}>
                    <div className="modal-form">
                        {accionError && <div className="patient-state patient-state--error">{accionError}</div>}
                        <label className="form-field">
                            <span>Servicio</span>
                            <select
                                value={servicioSeleccionado}
                                onChange={(e) => setServicioSeleccionado(e.target.value)}
                            >
                                {serviciosDisponibles.map((s) => (
                                    <option key={s.id} value={s.id}>{s.nombre}</option>
                                ))}
                            </select>
                        </label>
                        <div className="modal-form__actions">
                            <button className="btn-ghost" onClick={() => setModalAbierto(false)}>Cancelar</button>
                            <button className="primary-button" onClick={agregar} disabled={guardando}>
                                {guardando ? "Guardando..." : "Agregar"}
                            </button>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Servicios;